module.exports = __webpack_public_path__ + "img/banque.b1187dd1.jpg";